import React from 'react';
import ReactDOM from 'react-dom';
import App from './app';
import {
  GlobalAlert,
  GlobalAlertService,
  ThemeProvider,
} from '@trustpilot/businessapp-patternlibrary';
import { init as initAnalytics } from './analytics';

initAnalytics();

const url = new URL(window.location.href);
const query = url.searchParams.get('settings');
const settings = query ? atob(query) : null;
const settingsJson = settings ? JSON.parse(settings) : {};

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider>
      <App settings={settingsJson} />
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

const globalAlertElement = document.createElement('div');
document.body.appendChild(globalAlertElement);
ReactDOM.render(
  <ThemeProvider>
    <GlobalAlert
      subscribe={GlobalAlertService.subscribe}
      unsubscribe={GlobalAlertService.unsubscribe}
    />
  </ThemeProvider>,
  globalAlertElement
);